import { createApiCall } from 'lib/base';

const POST_COMPANY_SELL_ALL_ORDERS_API_ID =
  'FLEX/POST_COMPANY_SELL_ALL_ORDERS_API_ID';

const apiCall = createApiCall(
  POST_COMPANY_SELL_ALL_ORDERS_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/employee-programs/${id}/create-company-sell-all`,
    method: 'POST',
    body: payload,
    isStay: true,
    notify: true,
  })
);

export default apiCall;
